import moment from 'moment';
import { Moment } from 'moment';

export class DatePart {

    public static fromNumeric(year: number, month: number, day: number): DatePart {
        return new DatePart({ year, month, day });
    }

    public static fromYear(year: number): DatePart {
        return new DatePart({ year, month: 0, day: 1 });
    }

    public static fromMoment(momentInstance: Moment): DatePart {
        return new DatePart(momentInstance);
    }

    public static now(): DatePart {
        return new DatePart();
    }

    private _isADatePartObject: boolean;
    private _moment: Moment;

    constructor(arg?: any) {
        this._isADatePartObject = true;
        if (this._isADatePartObject) {
            // nop
        }

        if (arg) {
            if (arg._isADatePartObject) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                this._moment = arg._moment.clone();
            } else if (arg._isADateMomentObject) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                this._moment = arg.clone();
            } else if (arg instanceof Date) {
                this._moment = moment.utc({ year: arg.getFullYear(), month: arg.getMonth(), day: arg.getDate() });   // Otherwhise may be changed to utc time
            } else {
                this._moment = moment.utc(arg);
            }
        } else {
            this._moment = moment().utc();
        }
        this._moment.startOf('date');
    }

    public toString(): string {
        return this._moment.format('YYYY-MM-DD');
    }

    public toISOString(): string {
        return this._moment.toISOString();
    }

    public timestamp(): string {
        return this._moment.format('YYYYMMDDHHmmss');
    }

    public add(amount: number, part: moment.unitOfTime.DurationConstructor): DatePart {
        return DatePart.fromMoment(this._moment.clone().add(amount, part));
    }

    public subtract(amount: number, part: moment.unitOfTime.DurationConstructor): DatePart {
        return DatePart.fromMoment(this._moment.clone().subtract(amount, part));
    }

    public isBefore(another: DatePart): boolean {
        return this._moment.isBefore(another ? another._moment : null, 'day');
    }

    public isSameOrBefore(another: DatePart): boolean {
        return this._moment.isSameOrBefore(another ? another._moment : null, 'day');
    }

    public isAfter(another: DatePart): boolean {
        return this._moment.isAfter(another ? another._moment : null, 'day');
    }

    public isSameOrAfter(another: DatePart): boolean {
        return this._moment.isSameOrAfter(another ? another._moment : null, 'day');
    }

    public isBetween(start: DatePart, end: DatePart): boolean {
        return this._moment.isBetween(start ? start._moment : null, end ? end._moment : null, 'day', '[]');
    }

    public diffDays(other: DatePart): number {
        return other ? other._moment.diff(this._moment, 'days') : 0;
    }

    public isSame(another: DatePart): boolean {
        return this._moment.isSame(another ? another._moment : null, 'day');
    }

    // public startOf(unit: string): DatePart {
    //   return DatePart.fromMoment(this._moment.clone().startOf(unit));
    // }

    // public endOf(unit: string): DatePart {
    //   return DatePart.fromMoment(this._moment.clone().endOf(unit));
    // }

    public year(): number {
        return this._moment.year();
    }

    public month(): number {
        return this._moment.month();
    }

    public date(): number {
        return this._moment.date();
    }

    public toDate(): Date {
        return this._moment.toDate();
    }
}
